import gql from 'graphql-tag';

export const GET_MESSAGE_DELIVERY_LIST = gql`
query(
    $golf_code: String!
    $begin_row: Int
    $limit_rows: Int
){
    GetMessageDeliveryList(
        golf_code: $golf_code
        begin_row: $begin_row
        limit_rows: $limit_rows
    ){
        MessageDeliveryList{
            id
            delivery_date
            golf_code
            delivery_caption
            delivery_contents
            delivery_flag
            valid_flag
        }
        count
    }
}
`;

export const REGIST_MESSAGE_DELIVERY = gql`
mutation(
    $delivery_date: String!
    $golf_code: String!
    $delivery_contents: String!
){
    RegistMessageDelivery(
        delivery_date: $delivery_date
        golf_code: $golf_code
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const UPDATE_MESSAGE_DELIVERY = gql`
mutation(
    $id: ID!
    $delivery_date: String!
    $golf_code: String!
    $delivery_contents: String!
){
    UpdateMessageDelivery(
        id: $id
        delivery_date: $delivery_date
        golf_code: $golf_code
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const DELETE_MESSAGE_DELIVERY = gql`
mutation(
    $id: ID!
    ){
    DeleteMessageDelivery(
        id: $id
    ){
        result
    }
}
`;
